import { constants } from '@yola/subscription-manager-js';

const {
  SubscriptionType: { B2C_HOSTING_GOLD, B2C_HOSTING_SILVER, B2C_HOSTING_BRONZE },
} = constants;

export default {
  [B2C_HOSTING_BRONZE]: 'Personal',
  [B2C_HOSTING_SILVER]: 'Business',
  [B2C_HOSTING_GOLD]: 'Business Elite',
};
